<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_ca1"
      :custom="{ storage: true }"
      export
      :refresh="{ query: findList }"
    >
      <template v-slot:buttons>
        <el-button @click="funcFilter()">
          查询
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="85%"
      :data="tableData"
      export-config
      show-overflow
      align="center"
      :loading="loading"
      auto-resize
      @sort-change="sortList"
    >
      <vxe-table-column>
        <vxe-table-column
          field="shippingNoteNumber"
          title="托运单号"
          min-width="200"
        />
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="driverName"
          title="实际承运人姓名"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.driverName"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="licenseNumber"
          title="车牌号"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.licenseNumber"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="appType"
          title="上报来源"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.appType"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="stage"
          title="上报定位阶段"
          :formatter="
            ({ cellValue }) => formatterOptions({ cellValue }, 'stage')
          "
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.stage" clearable placeholder="请选择">
            <el-option
              v-for="item in stageOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="status"
          title="上报状态"
          :formatter="
            ({ cellValue }) => formatterOptions({ cellValue }, 'status')
          "
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.status" clearable placeholder="请选择">
            <el-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="errorCode"
          title="上报错误代码"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.errorCode"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="errorMsg"
          title="上报错误信息"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.errorMsg"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          title="上报时间"
          min-width="320"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
  </div>
</template>
<script>
import { orderReportRecord } from "@/api/transport";
export default {
  name: "InvoiceList",
  data() {
    return {
      message: "",
      loading: false,
      tableData: [],
      codes: "",
      listQuery: {
        gmtCreatedRange: "",
        shippingNoteNumber: "",
        pageNum: 1,
        pageSize: 20,
        total: 0
      },
      stageOptions: [
        { value: 0, label: "认证" },
        { value: 1, label: "开启" },
        { value: 2, label: "发送" },
        { value: 3, label: "暂停" },
        { value: 4, label: "重启" },
        { value: 5, label: "结束" }
      ],
      statusOptions: [{ value: 0, label: "成功" }, { value: 1, label: "失败" }],
      Pagingconf: []
    };
  },

  methods: {
    init(shippingNoteNumber) {
      this.tableData = [];
      (this.listQuery = {
        gmtCreatedRange: "",
        shippingNoteNumber: shippingNoteNumber,
        pageNum: 1,
        pageSize: 20,
        total: 0
      }),
        this.findList();
    },
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        orderReportRecord(this.listQuery).then(response => {
          response.data.total > 10000
            ? (this.Pagingconf = [20, 30, 50, 100, 10000])
            : (this.Pagingconf = [20, 30, 50, 100, response.data.total || 1]);
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.sumObject = response.data.sumObject;
          this.loading = false;
          resolve();
        });
      });
    },
    funcFilter() {
      this.listQuery.pageNum = 1;
      this.findList();
    },
    // 翻页
    handlePageChange({ currentPage, pageSize }) {
      this.listQuery.pageNum = currentPage;
      this.listQuery.pageSize = pageSize;
      this.findList();
    },
    // 排序
    sortList({ column, property, order }) {
      this.listQuery.sortField = property;
      this.listQuery.sortType = order;
      this.findList();
    },
    funcCancel() {
      this.$emit("onHideModel");
    },
    //翻译
    // 翻译
    formatterOptions({ cellValue }, prefix) {
      const item = this[`${prefix}Options`].find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    // 时间
    changeDate(value, prefix) {
      if (value) {
        this.listQuery[`${prefix}Start`] = value[0] + " 00:00:00";
        this.listQuery[`${prefix}End`] = value[1] + " 23:59:59";
      } else {
        this.listQuery[`${prefix}Start`] = "";
        this.listQuery[`${prefix}End`] = "";
      }
    }
  }
};
</script>
